<template>
  <v-dialog
    v-model="show"
    :width="$attrs.width"
    content-class="dialog-base"
    persistent>
    <v-card>
      <div
        class="d-flex align-center justify-space-between primary white--text fill-width"
        style="height: 60px; padding: 0 20px;">
        <div
          class="d-flex align-center">
          <div v-if="showOctagon" class="octagon white--text">!</div>
          <span
            :class="{
              'font-weight-bold ui-text-xl': true,
              'ml-2': showOctagon
            }">
            {{ title }}
          </span>
        </div>
        <v-icon
          size="26"
          color="white"
          @click="$emit('close')">
          mdi mdi-close
        </v-icon>
      </div>
      <div :style="disableBodyPadding ? '' : 'padding: 20px;'">
        <slot name="body"></slot>
      </div>
      <v-divider />
      <div
        class="d-flex flex-row align-center"
        style="padding: 20px;">
        <slot name="actions"></slot>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "InvoiceParameterDefaultModal",
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    title: {
      type: String,
      default: '',
      required: true,
    },
    showOctagon: {
      type: Boolean,
      default: false,
    },
    disableBodyPadding: {
      type: Boolean,
      default: false,
    }
  }
}
</script>
<style lang="scss">
.octagon {
  --size: 21px;
  --bg: var(--v-error-base);
  --border: var(--v-border-base);
  --border-width: 2px;
  --fg: var(--v-foreground-base);

  position: relative;
  width: var(--size);
  aspect-ratio: 1;
  display: grid;
  place-items: center;
  color: var(--fg);
  font: 800 calc(var(--size) * 0.70)/1 system-ui, sans-serif;
  clip-path: polygon(
    29.3% 0, 70.7% 0,
    100% 29.3%, 100% 70.7%,
    70.7% 100%, 29.3% 100%,
    0 70.7%, 0 29.3%
  );
}

.octagon::before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--border);
  clip-path: inherit;
  z-index: -1;
}

.octagon::after {
  content: "";
  position: absolute;
  inset: var(--border-width);
  background: var(--bg);
  clip-path: inherit;
  z-index: -1;
}

.dialog-base {
  max-height: 1000px !important;
}
</style>